import { render, staticRenderFns } from "./SortColumn.vue?vue&type=template&id=ff87d350&scoped=true"
import script from "./SortColumn.vue?vue&type=script&lang=ts"
export * from "./SortColumn.vue?vue&type=script&lang=ts"
import style0 from "./SortColumn.vue?vue&type=style&index=0&id=ff87d350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff87d350",
  null
  
)

export default component.exports